"use strict";

var validUrl = /^https?:\/\//i;

module.exports = function (options) {
  if (!validUrl.test(options.url)) {
    throw new Error("\"" + options.url + "\" is not a valid URL");
  }
};
//# sourceMappingURL=defaultOptionsValidator.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/get-it/lib/middleware/defaultOptionsValidator.js
// module id = 168
// module chunks = 0